import { render, staticRenderFns } from "./chatOrder.vue?vue&type=template&id=38404452&scoped=true"
import script from "./chatOrder.vue?vue&type=script&lang=js"
export * from "./chatOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38404452",
  null
  
)

export default component.exports